import { ThemeType } from "@intelligems/ig-types";

/**
 * A theme's `updatedAt` as epoch milliseconds, for sorting by recency.
 *
 * Shopify sends an ISO-8601 timestamp with an offset — real payload:
 * `"2024-08-08T14:52:09-06:00"`. `Number()` reads that as `NaN`, and a
 * comparator returning `NaN` leaves the pair untouched, so every "most
 * recently updated" sort built on it silently did nothing: the list kept the
 * order `GET /admin/api/2023-10/themes.json` returns, which is id-ascending
 * (creation order). That REST endpoint takes no sort parameter, so ordering
 * client-side is the only option and this is the only place that does it.
 *
 * Unparseable values sort last rather than nowhere, so a format change
 * degrades visibly instead of quietly reviving that bug.
 */
export function themeUpdatedAtMs(theme: ThemeType): number {
  const ms = Date.parse(theme.updatedAt);
  return Number.isNaN(ms) ? 0 : ms;
}
